import type Phaser from 'phaser';

import type { RegionDefinition } from '@/domain/world/region-definition';
import type { RegionRendererHandle } from './types';

type ProceduralRegionBuilder = (
  scene: Phaser.Scene,
  region: RegionDefinition,
) => RegionRendererHandle;

let registeredBuilder: ProceduralRegionBuilder | null = null;

export function registerProceduralRegionRenderer(builder: ProceduralRegionBuilder): void {
  registeredBuilder = builder;
}

export function buildProceduralRegionRenderer(
  scene: Phaser.Scene,
  region: RegionDefinition,
): RegionRendererHandle {
  if (registeredBuilder) return registeredBuilder(scene, region);

  const colors = { meadow: 0x528a48, forest: 0x2a5028, cave: 0x2c2a3a, coast: 0xd4b482 };
  const fallback = scene.add
    .rectangle(
      region.bounds.x,
      region.bounds.y,
      region.bounds.w,
      region.bounds.h,
      colors[region.biome],
    )
    .setOrigin(0)
    .setDepth(-100);
  return { destroy: () => fallback.destroy() };
}
